const updateDate = date => dispatch => {
  dispatch({
    type: "UPDATE_DATE",
    payload: date
  });
};

export default updateDate;



// WEBPACK FOOTER //
// ./src/actions/date.js